<template>
  <Hero :title="data?.header.title" :subtitle="data?.header.subtitle" :narrow="true" :images="data?.header.images"/>
  <main class="main">
    <article class="maxw--waist block rendered text--default" v-html="$md.render(data?.content || '')"></article>
  </main>
</template>

<script lang="ts" setup>
import IntroductionPage from '~/typings/pages/introduction_page';

useHead({
  title: 'Geschiedenis SV Virgo'
});

const { findOne } = useStrapi();

const { data } = await useAsyncData(
  'introductionpage',
  () => findOne<IntroductionPage>('history-page', { populate: ['header', 'header.images'] }),
  {
    transform: flattenStrapiObject
  }
);
</script>
